import React, { useState } from 'react';
import { ContactsMapProps } from './Contacts.props';
import styles from './Contacts.module.scss';
import loading from '../../assets/Loading_icon.gif';

const ContactsMap: React.FC<ContactsMapProps> = () => {
    const [isLoading, setIsLoading] = useState(true);
    const handleMapLoad = () => {
        setIsLoading(false);
    };

    return (
        <div className={styles.map}>
            <div className={'container'}>
                <div className={styles['map__inner']}>
                    {isLoading && <div className={styles.loader}><img src={loading} alt="loading" /></div>}
                    {/* Office location: 40.383603, 49.868374 */}
                    <iframe
                        width='100%' height='100%'
                        frameBorder='0' scrolling='no'
                        marginHeight={0} marginWidth={0}
                        onLoad={handleMapLoad}
                        src='https://www.openstreetmap.org/export/embed.html?bbox=49.862374%2C40.379603%2C49.874374%2C40.387603&amp;layer=mapnik&amp;marker=40.383603%2C49.868374'></iframe>
                    <div className={styles['map__overlay']}>
                        <div className={styles['map__overlay-title']}>PulPal MMC</div>
                        <div className={styles['map__overlay-text']}>
                            Rövşən Əliyev küçəsi 27,<br />AVA Business Center, 602-ci otaq,<br />AZ 1025
                        </div>
                        <a
                            className={styles['map__overlay-btn']}
                            href='https://www.google.com/maps?q=40.383603,49.868374&ll=40.383603,49.868374&z=16'
                            target='_blank' rel='noreferrer'
                        >
                            Yol tarifi al →
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactsMap;